/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function SelectWrapper(props) {
  const {
    label,
    hasError,
    children,
    inputRef,
    field: { onBlur, onChange, onFocus, value, ...fieldAttrs },
    fieldClass,
    labelClass,
    focused,
    handleBlur,
    handleFocus,
    handleChange,
    options,
    append,
    readOnly,
    autofocus,
    placeholder,
    disabled,
    defaultValue,
    floating = false,
    ...attrs
  } = props;
  const { t } = useTranslation();
  const fieldClasses = classNames(!value && 'no-value', fieldClass && fieldClass);

  const onHandleChange = (e) => {
    onChange(e);
    if (handleChange) handleChange(e);
  };

  const onHandleBlur = (e) => {
    onBlur(e);
    if (handleBlur) handleBlur(e);
  };

  const onHandleFocus = (e) => {
    if (onFocus) onFocus(e);
    if (handleFocus) handleFocus(e);
  };

  return (
    <>
      {autofocus && label && value && (
        <Form.Label
          className={classNames('visually-hidden', labelClass && labelClass)}
          aria-hidden="true"
        >
          {label}
        </Form.Label>
      )}
      {!autofocus && label && (
        <Form.Label className={classNames('mb-2', labelClass && labelClass)}>{label}</Form.Label>
      )}
      <div
        className={`position-relative ${!floating || 'form-floating'} flex-grow-1${
          value ? '' : ' no-float-label'
        }`}
      >
        <Form.Select
          className={fieldClasses}
          isInvalid={hasError}
          ref={inputRef}
          disabled={readOnly || disabled}
          onBlur={onHandleBlur}
          onFocus={onHandleFocus}
          onChange={onHandleChange}
          defaultValue={defaultValue}
          value={!defaultValue && (value === null || value === undefined ? '' : value)}
          style={{ backgroundImage: 'none' }}
          {...fieldAttrs}
          {...attrs}
        >
          {!value && <option aria-label="Select from Dropdown" default value="" />}
          {options.length > 0 &&
            options.map((option, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <option key={index} value={option.value} disabled={option.disabled}>
                {option.label}
              </option>
            ))}
        </Form.Select>
        {autofocus && (
          <Form.Label
            className={classNames((value || focused) && 'shrink', labelClass && labelClass)}
          >
            {placeholder || label || t('common:form.fields.select.placeholder')}
          </Form.Label>
        )}
        {append && append}
      </div>
      {children}
    </>
  );
}

SelectWrapper.propTypes = {
  /**
   * field is required and must be an object
   */
  field: PropTypes.object.isRequired,
};

export default SelectWrapper;
